import { AfterViewInit, Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '@app/@core/local-storage/local-storage.service';
import { AlertService } from '@app/@core/services/alert.service';
import { AppService } from '@app/@core/services/app.service';
import { AuthService } from '@app/@core/services/auth.service';
import { SharedService } from '@app/@core/services/shared.service';
import { GridListService } from '@app/pages/rbac/access-management/common-components/grid-list/grid-list.service';
import { LocalService } from '@core/services/local.service';
import { InAppNotificationService } from '@pics-core/common-utils';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import { saveAs } from 'file-saver-es';
import * as jsPDF from 'jspdf';
import * as moment from 'moment';

@Component({
  standalone: false,
  selector: 'app-grid-list',
  providers: [GridListService],
  templateUrl: './grid-list.component.html',
  styleUrls: ['./grid-list.component.scss']
})
export class GridListComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  @Input() dataList: any[] = [];
  @Input() dataSource: DataSource;
  @Input() columns: any;
  @Input() updateGrid: any;
  @Input() totalCount: number;
  @Input() page: number;
  @Input() isShow: boolean;
  @Input() remoteOperations: boolean;
  @Input() enableExport: boolean;
  @Input() showHeaderFilter: boolean;
  @Input() exportPageName: string;
  registrationInfo: any;
  url: string;
  oldUrl: string;
  alertService: AlertService;
  inAppNotificationService: InAppNotificationService;
  sharedService: SharedService;
  appService: AppService;
  storageService: LocalStorageService;
  localstorage: LocalService;
  @Input() set pageSize(value: number) {
    if (value) {
      this.currentPageSize = value;
    } else {
      this.currentPageSize = 20;
    }
  }
  @Output() currentPage = new EventEmitter<number>();
  @Output() pageIndex = new EventEmitter<number>();
  @Output() currentSize = new EventEmitter<number>();
  @Output() editTableRow = new EventEmitter<any>();
  @Output() viewTableRow = new EventEmitter<any>();
  @Output() deleteTableRow = new EventEmitter<any>();
  @Output() openExternalLink = new EventEmitter<any>();
  @Output() openpopupLink = new EventEmitter<any>();
  @Output() routeTo = new EventEmitter<any>();
  @Output() openPopup = new EventEmitter<any>();
  @Output() duplicateRow = new EventEmitter<any>();
  @Output() sortOrder = new EventEmitter<any>();
  @Output() filterSearchValue = new EventEmitter<any>();
  @Output() filterBuilderPopup = new EventEmitter<any>();
  @Output() filterPanel = new EventEmitter<any>();
  @Output() multipleFilterValues = new EventEmitter<any>();
  @Output() downloadTableRow = new EventEmitter<any>();
  @Output() toggleRow = new EventEmitter<any>();
  @Output() outComeTableRow = new EventEmitter<any>();
  @Output() downloadFormResponseFiles = new EventEmitter<any>();
  @Output() deleteFormResponseFiles = new EventEmitter<any>();
  @Output() rowSelection = new EventEmitter<any>();
  @Output() navigate = new EventEmitter<any>();
  @Output() multipleFilterValueToAPI = new EventEmitter<any>();
  @Output() selectedRowsData = new EventEmitter<any>();
  dataField: string[];
  columnHeader: any[];
  popupPosition: any;
  filterValue: (string | string[])[];
  customOperations: any[];
  fields: any;
  customStore: any;
  tempColumns: any[];
  Organization: any;
  dUrl: string;
  rdUrl: string;
  rUrl: any;
  user: any;
  displayMode: string;
  currentPageSize: any;
  currentFilter: any;
  headerFilterData: any;
  constructor(
    injector: Injector,
    private router: Router,
    public auth: AuthService,
  ) {
    this.alertService = injector.get<AlertService>(AlertService);
    this.inAppNotificationService = injector.get<InAppNotificationService>(InAppNotificationService);
    this.sharedService = injector.get<SharedService>(SharedService);
    this.appService = injector.get<AppService>(AppService);
    this.storageService = injector.get<LocalStorageService>(LocalStorageService);
    this.localstorage = injector.get<LocalService>(LocalService);
    /**
     * initiating the grid list
     */
    this.loadGWithParam();

    /**
     * fetching login details from local storage
     */
    this.user = this.localstorage.getObj('user');
    this.displayMode = 'compact';
    this.currentFilter = 'auto';
  }

  ngOnInit() {
    this.rUrl = this.router.url.split('/');
    this.tempColumns = this.columns;
    if (this.columns && this.columns.gridConfigFormArray) {
      this.columnHeader = this.columns.gridConfigFormArray.map(column => column.header);
      this.columns = this.columns.gridConfigFormArray;
    } else {
      this.columnHeader = this.columns.map(column => column.header);
    }
    this.popupPosition = { of: window, at: 'top', my: 'top', offset: { y: 10 } };
    this.filterValue = [];
    this.customOperations = [];
  }

  /**
   * re-render the grid when input data is changed.
   */
  ngOnChanges() {
    this.loadGWithParam();
  }

  /**
   * Rendering data grid condition wise that login user is admin or not
   */
  loadGWithParam() {
    if (!this.auth.isAdmin()) {
      this.loadGrid({ value: !this.Organization ? this.auth.getOrgID() : this.Organization }, false);
    } else {
      this.loadGrid({ value: this.Organization ? this.Organization : 'Select-ALL' }, false);
    }
  }

  ngAfterViewInit() {
    /**
     * Datagrid even listener we can customize column event
     */
    this.dataGrid.onRowClick.subscribe(row => {
      this.selectedRowsData.emit(row);
    });
    this.dataGrid.onOptionChanged.subscribe(e => {
      if (e.name === 'columns' && e.fullName.endsWith('filterValues')) {
        const colIndex = Number(
          e.fullName
            .match(/\[\d+\]/)[0]
            .replace('[', '')
            .replace(']', '')
        );
        e.component.columnOption(colIndex, 'filterValues');
        this.multipleFilterValues.emit(e);
      }

      // Search
      if (e.name === 'columns' && e.fullName.endsWith('filterValue')) {
        console.log(e);
        this.filterSearchValue.emit(e);
      }

      // filter Builder Popup

      if (e.name === 'filterBuilderPopup') {
        console.log('filterBuilderPopup');
        console.log(e);
        this.filterBuilderPopup.emit(e);
      }

      // filter Panel - enable or disable
      if (e.name === 'filterPanel') {
        console.log(e.value);
        this.filterPanel.emit(e);
      }

      // Sorting
      if (e.name === 'columns' && e.fullName.endsWith('sortOrder')) {
        this.sortOrder.emit(e);
      }

      // Paging
      if (e.name === 'paging') {
        this.currentPage.emit(e.value);
      }
      // pageIndex
      if (e.fullName === 'paging.pageIndex') {
        this.pageIndex.emit(e.value);
      }
      // pageSize
      if (e.fullName === 'paging.pageSize') {
        this.currentSize.emit(e.value);
      }
    });
    const REGISTRATION = this.storageService.getItem('REGISTRATION');
    if (REGISTRATION) {
      this.registrationInfo = JSON.parse(REGISTRATION);
    }
  }

  /**
   * Generating data grid and restructuring data for Developer grid
   * @param orgID origination details
   * @param load optional boolean is for checking data should load organization respective or all
   */
  loadGrid(orgID, load = true) {
    this.Organization = orgID.value;
    if (load) {
      this.currentPage.emit(orgID.value === 'Select-ALL' ? 'all' : orgID.value);
    }

    if (this.dataList?.length && this.rUrl && this.rUrl[2] === 'view-dashboard') {
      this.dUrl = 'view-dashboard/dashboard';
      this.router.navigateByUrl(`pages/${this.dUrl}/${this.dataList[0]['id']}`);
    }
    this.customStore = new CustomStore({
      load: _opts => {
        this.multipleFilterValueToAPI.emit(_opts.filter);
        return Promise.resolve(this.dataList);
      },
      totalCount: _opts => Promise.resolve(this.totalCount)
    });
  }

  getRouter(data) {
    this.routeTo.emit(data);
  }
  navigateLink(event: MouseEvent, rowData: any) {

    /* Prevent other events */
    event.stopPropagation();
    const target = event.target as HTMLAnchorElement;
    if (target.tagName === 'A' && target.href) {
      this.updateNotificationView(rowData);
      this.url = this.extractUrl(target.outerHTML);
      this.oldUrl = this.extractUrl(target.outerHTML);
      const activeId = this.extractID(this.url.split('?')[0]);
      const isNumberCheck = Number(activeId);
      const urlParams = new URLSearchParams(this.url.split('?')[1]);
      const pageID = urlParams.get('pageID');
      event.preventDefault();
      if (pageID) {
        this.inAppNotificationService.checkPageAccessForUser(pageID).subscribe((res: any) => {
          if (res['data']) {
            this.checkPageId(isNumberCheck, activeId, event);
          } else {
            event.preventDefault();
            this.alertService.error("Page Not Available: You don't have the necessary permissions to view this page.");
          }
        }, (_error) => {
          event.preventDefault();
          this.alertService.error("An error occurred while checking page access.");
        });
      } else {
        event.preventDefault();
        this.alertService.error("Page Not Available");
      }
    }
  }

  async checkPageId(isNumberCheck, activeId, event) {
    if (isNumberCheck) {
      const menus = this.localstorage.getObj('MENU');
      const findMenu = menus.find(item => item.name === 'Pages');
      let isExists;
      if (findMenu && findMenu.length > 0) {
        isExists = findMenu.submenu.find(item => item.id == isNumberCheck);
      }
      if (isExists) {
        this.url = this.url.replace(activeId, isExists?.activeVersion?.pageid);
        this.routeFunction(isNumberCheck, activeId, event, 'mainMenuWithId');
      } else {
        this.routeFunction(isNumberCheck, activeId, event, 'Pages');
      }
    } else {
      this.routeFunction(isNumberCheck, activeId, event, 'mainMenuWithURL');
    }
  }

  routeFunction(isNumberCheck, activeId, event, _menuType) {
    const menus = this.localstorage.getObj('MENU');
    const mainMenu = menus.find(item => item.route === this.url);
    const mainMenuWithUrl = menus.find(element => this.url.endsWith(element.route));
    if (mainMenuWithUrl) {
      this.appService.addValue('CurrentPages', mainMenuWithUrl);
      this.auth.getCurrentMenu(menus);
    } else if (mainMenu) {
      menus.forEach(element => {
        if (element.name === mainMenu.name) {
          element.active = true;
        } else {
          element.active = false;
        }
      });
      if (isNumberCheck) {
        this.appService.addValue('dynamicPages', mainMenu);
        this.auth.getCurrentMenu(menus);
      } else {
        this.appService.addValue('currentPages', mainMenu);
        this.auth.getCurrentMenu(menus);
      }
    } else {
      menus.forEach((element, index) => {
        if (element.submenu.length > 0) {
          element.submenu.forEach((element1, index1) => {
            if (element1?.route == this.url || element1?.activeVersion?.pageid == activeId || element1?.activeVersion?.id == activeId) {
              this.setActive(menus, index, index1, isNumberCheck);
            }
          });
        }
        //  else if(element.submenu.length > 0 && element.name == 'Pages'){
        //   element.submenu.forEach((element1, index1) => {
        //     if(element1?.activeVersion?.pageid == activeId){
        //       this.setActive(menus, index, index1, isNumberCheck);
        //     }
        //   });
        // }
      });
    }
    this.router.navigateByUrl(this.oldUrl);
    event.preventDefault();
  }

  setActive(menus: any, menuIndex, submenuIndex, isNumberCheck) {
    menus.map(item => item.active = false);
    menus.forEach(element => {
      element.submenu.map(item => item.active = false);
    });
    if (menuIndex) {
      menus[menuIndex].active = true;
      if (submenuIndex >= 0) {
        menus[menuIndex].submenu[submenuIndex].active = true;
      } else {
        menus[menuIndex].active = true;
      }
    } else {
      menus[0].active = true;
    }
    if (isNumberCheck) {
      this.appService.addValue('dynamicPages', menus[menuIndex]);
      this.auth.getCurrentMenu(menus);
    } else {
      this.appService.addValue('currentPages', menus[menuIndex]);
      this.auth.getCurrentMenu(menus);
    }
  }

  extractID(url: string) {
    const parts = url.split("/");
    const lastIndex = parts.length - 1;
    return parts[lastIndex];
  }

  extractUrl(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const link = doc.querySelector('a');
    return link ? link.getAttribute('href') : '';
  }

  navigateTo(data) {
    this.navigate.emit(data);
  }

  popup(data) {
    this.openPopup.emit(data);
  }

  downloadData(evt) {
    this.downloadTableRow.emit(evt);
  }

  editData(evt) {
    this.editTableRow.emit(evt);
  }
  editDataMyApplciation(evt) {
    this.editTableRow.emit(evt);
  }
  editAppeal(evt) {
    this.editTableRow.emit(evt);
  }
  onSelectionChanged(evt) {
    this.rowSelection.emit(evt);
  }

  viewData(evt) {
    this.viewTableRow.emit(evt);
  }

  deleteData(evt) {
    this.deleteTableRow.emit(evt);
  }

  duplicateDate(evt) {
    this.duplicateRow.emit(evt);
  }

  openLink(evt) {
    this.openExternalLink.emit(evt);
  }

  openPopupLink(evt) {
    this.openpopupLink.emit(evt);
  }

  activeUser(evt) {
    this.toggleRow.emit(evt);
  }
  getVisabilityByChoosableProp(chooser, visible) {
    if (chooser) {
      return visible;
    } else {
      return true;
    }
  }

  getSortOrder(defaultSortColumn, defaultSortType, columnDef) {
    if (defaultSortColumn && defaultSortType) {
      return defaultSortColumn === columnDef ? defaultSortType : '';
    }
    return '';
  }
  outComeData(evt) {
    this.outComeTableRow.emit(evt);
  }

  downloadFormResponseAttachments(evt) {
    this.downloadFormResponseFiles.emit(evt);
  }

  deleteFormResponseAttachments(evt) {
    this.deleteFormResponseFiles.emit(evt);
  }

  onRowPrepared(e) {
    if (e.rowType == 'data' && e.data.isnew) {
      const element = e.rowElement;
      element.classList.add('isnew');
    }
  }

  onCellPrepared(e) {
    if (e.rowType == 'data') {
      if (e.column.dataField === 'notice') {
        const element = e.cellElement;
        e.cellElement.innerHTML = '';
        const livetext = document.createElement('div');
        this.checkOncellprepare(e, livetext);
        element.appendChild(livetext);
      } else if (e.column.dataField === 'notificationEventChannels') {
        const element = e.cellElement;
        e.cellElement.innerHTML = '';
        const livetext = document.createElement('div');
        let ele = '';
        e.data.notificationEventChannels.map(t => {
          if (t.templatename) {
            ele += `<label>${t.templatename}&nbsp;(<b>${t.templatechannel}</b>)</label>,`;
          }
        });
        livetext.innerHTML = ele;
        element.appendChild(livetext);
      } else if (e.column.dataField === 'link') {
        const element = e.cellElement;
        e.cellElement.innerHTML = '';
        const livetext = document.createElement('div');
        livetext.innerHTML = `<img  src="${e.data.link ? e.data?.link?.split('?')[0] : ''
          }"style="max-width: 45px; cursor: pointer"/>`;
        element.appendChild(livetext);
      }
      this.checkCellprepare(e);
    }
  }
  checkCellprepare(e) {
    if (e.column.dataField === 'status' && e.data['tabname'] === 'RECORDS' && e.data['status'] === 'NO MATCH') {
      const element = e.cellElement;
      const livetext = document.createElement('span');
      livetext.classList.add('ml-2');
      livetext.innerHTML = `<em class="fa fa-info-circle" aria-hidden="true" title="${e.data?.execution_error?.error}" ></em>`;
      if (e.data?.execution_error?.error) {
        element.appendChild(livetext);
      }
    }
  }

  checkOncellprepare(e, livetext) {
    if (e.value !== 'No Data Found') {
      livetext.innerHTML = `<a class="btn-link loginLabel" href="${e.value}" target="_blank">Click Here<a>`;
    } else {
      livetext.innerHTML = 'No Data Found';
    }
  }

  onExporting(e) {
    const pageName = this.localstorage.getObj('FILE EXPORT NAME');
    const currentDate = moment().format('YYYY-MM-DD');
    let fileName: string;
    if (pageName) {
      fileName = `${pageName} Versions ${currentDate}`;
    } else if (this.exportPageName) {
      fileName = `${this.exportPageName}-${currentDate}`;
    } else {
      fileName = `Dynamic-Pages ${currentDate}`;
    }
    e.component.columnOption('Action', 'visible', false);
    if (e.format === 'pdf') {
      const doc = new jsPDF.jsPDF();
      exportDataGridToPdf({
        jsPDFDocument: doc,
        component: e.component,
        customizeCell: grid => {
          grid.pdfCell.wordWrapEnabled = true;
        }
      }).then(() => {
        doc.save(`${fileName}.pdf`);
        e.component.columnOption('Action', 'visible', true);
      });
    } else if (e.format === 'xlsx') {
      e.fileName = fileName;
      setTimeout(() => {
        e.component.columnOption('Action', 'visible', true);
      }, 500);
    } else if (e.format === 'csv') {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Main sheet');
      exportDataGrid({
        component: e.component,
        worksheet: worksheet
      }).then(function () {
        workbook.csv.writeBuffer().then(function (buffer) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${fileName}.csv`);
        });
      });

      e.cancel = true;
    }
  }
  contentReady = e => {
    const reorderColumns = e.component.instance().getVisibleColumns();
    console.log(reorderColumns, 'reorderColumns');
  };
  customizeHeaderFilterData(options) {
    options.dataSource.postProcess = results => {
      results.map(x => {
        x.text = x[options.dataSource.group[0].selector];
        x.value = [options.dataSource.group[0].selector, '=', x[options.dataSource.group[0].selector]];
        return x;
      });
      console.log(results, 'update customizeHeaderFilterData');
      return results;
    };
  }
  getDateFormat(value: any) {
    if (this.registrationInfo) {
      if (value === 'date') {
        return this.registrationInfo['datetimeformat'].split(' ')[0];
      }
      return this.registrationInfo['datetimeformat'];
    }
    return 'MM/dd/yyyy';
  }

  updateNotificationView(rowData) {
    const inputRequest = {
      isnew: false
    };
    const model = rowData?.data;
    this.inAppNotificationService.updateNotification(model?.id, inputRequest).subscribe((_res: any) => {
      this.sharedService.sendMessage();
    });
  }
}
